import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BRAND = "Good Eyes";
const SITE = "https://goodeyes.co.nz";

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Sets document title + primary SEO / OpenGraph / Twitter meta on route change.
 * Pass { title, description, path, image } — everything else falls back to sensible defaults.
 */
export default function useSEO({ title, description, path = "", image = `${SITE}/assets/logo-good.png` } = {}) {
  const location = useLocation();
  const canonical = `${SITE}${path || location.pathname}`;
  const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} — Reading Glasses, Colour-Coded by Strength`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta("description", description);
    setLink("canonical", canonical);

    // OpenGraph
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", BRAND, "property");
    setMeta("og:image", image, "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description);
    setMeta("twitter:image", image);
  }, [fullTitle, description, canonical, image]);
}
